import {BaseContainerModel} from '../../base-container.model';
import {bl_crm_membership_points_txn_line_RowClass} from '../../../dbschema/bl_crm_membership_points_txn_line.model';
import {bl_crm_membership_points_txn_hdr_RowClass} from '../../../dbschema/bl_crm_membership_points_txn_hdr.model';

export class MembershipPointsTxnLineContainerModel extends BaseContainerModel {
   bl_crm_membership_points_txn_line: bl_crm_membership_points_txn_line_RowClass = new bl_crm_membership_points_txn_line_RowClass();
}
